export const CustomerRoutes = {
  LIST: "/customers",
  DETAIL: "/customers/:id",
} as const;
